import Bridge from './Bridge'

/**
 * @class CustomBridge
 * @extends Bridge
 *
 * Расширяет базовый Bridge и добавляет логику для разбора типа события.
 *
 * @example
 * // Отправка сообщения в родительское окно:
 * CustomBridge.instance.send({name: "ADD_TO_FAVORITES", type: 0, data: {sku}});
 */
export default class CustomBridge extends Bridge {
  static _instance = null

  static get instance() {
    if (!this._instance) this._instance = new CustomBridge()

    return this._instance
  }

  /**
   * @inheritdoc
   *
   * Определяет тип события на основе `event.data.name`.
   *
   * @param {MessageEvent} event
   * @returns {"authorization"|"share"|"getUser"|"user"|"completedUser"|"getAppInfo"|"appInfo"|"unknownEvent"}
   */
  getEventType(event) {
    switch (event?.data?.name) {
      case 'AUTH':
        return 'authorization'
      case 'SHARE':
        return 'share'
      case 'GET_USER':
        return 'getUser'
      case 'USER':
        return 'user'
      case 'CHECK_USER_DATA_FILLED':
        return 'completedUser'
      case 'GET_APP_INFO':
        return 'getAppInfo'
      case 'APP_INFO':
        return 'appInfo'
      case 'SHOW_NOTIFICATION':
        return 'showNotification'
      case 'ADD_TO_FAVORITES_SUCCESS':
      case 'REMOVE_FROM_FAVORITES_SUCCESS':
        return 'favoritesSuccess'
      default:
        return 'unknownEvent'
    }
  }
}
